import { IComponentOptions } from "angular";
import { MachineDetailConfigurationsDecommissionController } from "./controller";

export const vsComponentName = "machineDetailConfigurationsDecommission";

export const MachineDetailConfigurationsDecommissionComponentOptions: IComponentOptions =
  {
    controller: MachineDetailConfigurationsDecommissionController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "componentController",
    bindings: {
      machine: "<",
    },
  };
